import React from 'react';

import { type NewCoreIconProps } from '@atlaskit/icon';
import PresenterModeIcon from '@atlaskit/icon/core/presenter-mode';

export const ManualTriggerIcon: React.FunctionComponent<NewCoreIconProps> = (props) => (
	<PresenterModeIcon color="currentColor" {...props} />
);
